<template>
    <div class="row py-lg-5">
        <div class="col-12 no-inner-padding">
            <div class="tiny-slider">
                <div v-for="image in images" :key="image.id">
                    <div class="position-relative" :style="computedHeight">
                        <LazyBackground :image="image"></LazyBackground>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { tns } from 'tiny-slider/src/tiny-slider';
import LazyBackground from '@/components/lazy-background';

export default {
    components: {
        LazyBackground
    },

    props: {
        images: {
            type: Array,
            default() {
                return [];
            }
        },
        slides: {
            type: Number,
            default: 1
        }
    },

    data() {
        return {
            slider: null
        };
    },

    computed: {
        computedHeight() {
            let height = 100;

            switch (this.slides) {
                case 1:
                    height = 45;
                    break;
                case 2:
                    height = 90;
                    break;
                case 3:
                    height = 135;
                    break;
                default:
                    height = 90;
            }

            if (window.innerWidth > 992) {
                return {
                    'padding-top': height + '%'
                };
            }

            return {
                'padding-top': '75%'
            };
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.initSlider();
        });
    },

    methods: {
        initSlider() {
            this.slider = tns({
                container: this.$el.querySelector('.tiny-slider'),
                items: 1,
                gutter: 20,
                loop: false,
                slideBy: 1,
                mouseDrag: true,
                swipeAngle: false,
                controls: false,
                lazyload: false,
                nav: true,
                navPosition: 'bottom',
                preventScrollOnTouch: 'auto',
                speed: 400,
                responsive: {
                    992: {
                        items: this.slides,
                        mouseDrag: false,
                        slideBy: this.slides
                    }
                }
            });
        }
    }
};
</script>

<style lang="scss">
.block-slider .tns-nav {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;

    button {
        flex: 0 0 18px;
        margin: 0 5px;
    }

    @include media-breakpoint-up(md) {
        justify-content: center;

        button {
            margin: 0 1rem;
        }
    }
}
</style>
